var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaymentMethodUsdtcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.20264,
    y: 3.84766,
    width: 21,
    height: 14.3043,
    rx: 2,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06282 6.04813L6.00869 10.3628C6.00087 10.3789 5.9984 10.397 6.00162 10.4146C6.00485 10.4321 6.0136 10.4482 6.02661 10.4604L11.5743 15.7764C11.5901 15.7916 11.6111 15.8 11.6329 15.8C11.6547 15.8 11.6757 15.7916 11.6915 15.7764L17.2392 10.4607C17.2522 10.4485 17.2609 10.4324 17.2642 10.4149C17.2674 10.3973 17.2649 10.3792 17.2571 10.3632L15.203 6.04846C15.1963 6.03397 15.1857 6.0217 15.1723 6.0131C15.1588 6.00451 15.1432 5.99996 15.1273 6.00001H8.13915C8.12314 5.99981 8.10742 6.00424 8.09387 6.01278C8.08032 6.02132 8.06954 6.0336 8.06282 6.04813Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3457 10.8059C12.3059 10.8089 12.1001 10.8211 11.6411 10.8211C11.276 10.8211 11.0168 10.8102 10.9258 10.8059C9.51494 10.7438 8.46182 10.4982 8.46182 10.2041C8.46182 9.91008 9.51494 9.66481 10.9258 9.60175V10.5613C11.0181 10.5679 11.2823 10.5835 11.6474 10.5835C12.0855 10.5835 12.3049 10.5653 12.3444 10.5616V9.60241C13.7523 9.66514 14.8031 9.91075 14.8031 10.2041C14.8031 10.4975 13.7526 10.7432 12.3444 10.8055L12.3457 10.8059ZM12.3457 9.50317V8.64455H14.3106V7.33521H8.961V8.64455H10.9255V9.50284C9.32874 9.57619 8.12793 9.89249 8.12793 10.2715C8.12793 10.6506 9.32874 10.9665 10.9255 11.0402V13.7916H12.3454V11.0392C13.9385 10.9659 15.1373 10.6499 15.1373 10.2712C15.1373 9.89249 13.9395 9.57652 12.3454 9.50284L12.3457 9.50317Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaymentMethodUsdtcoin);
export default __webpack_public_path__ + "static/media/icon_payment_method_usdtcoin.d929d8848b18b726d3f47eb7550fc907.svg";
export { ForwardRef as ReactComponent };